import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Alert from '@material-ui/lab/Alert';
import WarningIcon from '@material-ui/icons/Warning';

import { containerFluidCenter } from 'app/styles/new-layout';

const useStyles = makeStyles(theme => ({
    container: {
        ...containerFluidCenter(theme),
        padding: theme.spacing(3)
    },
    alertContainer: {
        maxWidth: 500,
        textAlign: 'center'
    },
    icon: {
        fontSize: 120,
        color: theme.palette.grey[400]
    },
    alert: {
        marginTop: theme.spacing(3),
        fontSize: 18
    }
}));

export default function BetaFeature(props) {

    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.alertContainer}>
                <WarningIcon className={classes.icon}/>
                <Alert severity="warning" className={classes.alert} icon={false}>
                    {props.alert}
                </Alert>
            </div>
        </div>
    )
}
